(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initReveal(){
    if (reduce.matches) return;
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('#MainContent .shopify-section');
    if (!targets.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('auri-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    Array.prototype.forEach.call(targets, function(el, i){
      if (i === 0) return;
      if (el.classList.contains('auri-reveal')) return;
      el.classList.add('auri-reveal');
      io.observe(el);
    });
  }

  function initParallax(){
    if (reduce.matches) return;
    var first = document.querySelector('#MainContent .shopify-section');
    if (!first) return;
    var media = first.querySelector('.banner__media, .slideshow__media, .media');
    if (!media) return;
    first.classList.add('auri-parallax');
    var ticking = false;
    function update(){
      var rect = first.getBoundingClientRect();
      if (rect.bottom >= 0 && rect.top <= window.innerHeight){
        var shift = Math.max(-60, Math.min(60, rect.top * -0.16));
        media.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0) scale(1.08)';
      }
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking){ ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function boot(){ initReveal(); initParallax(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
